import { useMemo, useState } from "react";
import EmbedController from "../../../../embed/EmbedController";
import { useComponentsIndex } from "../../../hooks/useComponentsIndex";
import { getFinalPrice } from "../../../modules/getFinalPrice";
import { getShoppingCartData } from "../../../modules/getShoppingCartData";
import { Boop } from "../Animations/Boop";
import { CardElementCart } from "../CardElement/CardElementCart";
import { ImgWithFallback } from "../ImgWithFallback/ImgWithFallback";
import { QuoteRequestModal } from "../QuoteRequestModal/QuoteRequestModal";
import "./styles.scss";

export const ShoppingCart = ({ productsState, componentsStateObj, itemsStateObj, previousComponentsState }) => {
  const componentsIndexObj = useComponentsIndex(componentsStateObj.state);
  const { deskModelIndex } = useComponentsIndex(componentsStateObj.state);
  const [ttCartData] = useMemo(() => {
    const [cartData, shopifyIds, shopifyBuilderSummary] = getShoppingCartData(componentsStateObj.state, itemsStateObj.state, componentsIndexObj);

    // Sort cart data by price: items with price > 0 first, then highest price first
    const sortedCartData = [...cartData].sort((a, b) => {
      const priceA = parseFloat(a.price) || 0;
      const priceB = parseFloat(b.price) || 0;

      // Items with price > 0 come before items with price = 0
      const hasPositivePriceA = priceA > 0 ? 1 : 0;
      const hasPositivePriceB = priceB > 0 ? 1 : 0;

      if (hasPositivePriceA !== hasPositivePriceB) {
        return hasPositivePriceB - hasPositivePriceA; // Items with positive price first
      }

      // Within the same price category, sort by highest price first
      if (priceA !== priceB) {
        return priceB - priceA; // Descending order (highest first)
      }

      // If prices are equal, maintain original order (stable sort)
      return 0;
    });

    return [sortedCartData, shopifyIds, shopifyBuilderSummary];
  }, [itemsStateObj.state, componentsIndexObj, componentsStateObj.state]);
  // const [isCartSubmissionPending, setIsCartSubmissionPending] = useState(false);
  const finalPrice = getFinalPrice(productsState, ttCartData);
  // const [sessionId] = useAtom(session_id);
  const [showQuoteModal, setShowQuoteModal] = useState(false);

  const handleBackClick = () => {
    componentsStateObj.setActiveId(previousComponentsState.includes("cart") ? componentsStateObj.state.array[deskModelIndex]._id : previousComponentsState);
  };

  const handleRequestQuote = () => {
    setShowQuoteModal(true);
  };

  return (
    <div className="ShoppingCart my-3">
      <div className="d-flex align-items-center justify-content-around mb-1">
        <Boop boopType="scale" scale="1.1" timing={200}>
          <ImgWithFallback
            src="/images/nav_btn_flags/back-btn-flag.webp"
            fallback="/images/nav_btn_flags/back-btn-flag.png"
            className="backButton"
            onClick={handleBackClick}
            onTouchStart={(e) => {
              e.preventDefault();
              handleBackClick();
            }}
          />
        </Boop>
        <h4 className="mb-0 font-weight-bold">Pricing Estimate</h4>
        <div style={{ width: "30px" }}></div>
      </div>
      <div className="d-flex mt-4 mb-3 align-items-center">
        <h5 className="mb-0">{`$${parseFloat(finalPrice).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</h5>
        <div style={{ marginLeft: "auto" }}>
          <button type="button" onClick={handleRequestQuote} className="ms-auto checkoutBtn">
            Request Exact Quote
          </button>
        </div>
      </div>

      <CardElementCart cardContentArray={ttCartData} imgFrame={false} />

      <QuoteRequestModal
        show={showQuoteModal}
        onHide={() => setShowQuoteModal(false)}
        configUrl={EmbedController?.parentUrl || window.location.href}
        estimatedCost={finalPrice}
      />
    </div>
  );
};
